import React from 'react'
import { Button } from '../ui'
import { FunnelSuggestion } from '../../types'

interface SuggestionCardProps {
  suggestion: FunnelSuggestion
  onApply: (suggestion: FunnelSuggestion) => void
}

export const SuggestionCard: React.FC<SuggestionCardProps> = ({ suggestion, onApply }) => {
  return (
    <div className="p-4 border border-border rounded-lg bg-card hover:border-accent/40 transition-colors">
      <div className="flex items-start justify-between mb-3 gap-3">
        <div className="min-w-0">
          <h4 className="font-semibold text-foreground text-sm">{suggestion.title}</h4>
          <p className="text-xs text-muted-foreground mt-0.5">{suggestion.description}</p>
        </div>
        <Button size="sm" variant="outline" onClick={() => onApply(suggestion)} className="flex-shrink-0">
          Aplicar
        </Button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {suggestion.statuses.map((step, stepIdx) => (
          <span
            key={stepIdx}
            className="inline-flex items-center gap-1.5 px-2 py-1 text-xs font-medium rounded-md bg-surface border border-border text-muted-foreground"
          >
            {/* Small color dot for stage identity */}
            <span
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{ backgroundColor: step.color }}
            />
            {step.label}
          </span>
        ))}
      </div>
    </div>
  )
}
